import React, { useState, useMemo, useEffect } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import FormCustom from '../../Components/Form/FormCustom';
import Button from 'react-bootstrap/esm/Button';
import Input from '../../Components/Form/Input';
import Select from '../../Components/Form/Select';

const ReportePromos = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    const [product, setProduct] = useState('');
    const [periodSelected, setPeriodSelected] = useState('')
    const [period, setPeriod] = useState([])

    const handleSubmit = _ => {
        setIsProccesing(true)
        Controllers.customers.report_promo_buy_customers({
            p_key_promo: product,
            p_id_period: periodSelected,
        }).then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
        })
    }, [])

    const dtRows = useMemo(() => {
        return <ReactDataTableBootstrap
            head={[
                [
                    { name: 'id_customers', text: 'ID' },
                    { name: 'full_name_customers', text: 'Nombres' },
                    {
                        name: 'name_branch_office', text: 'Sucursal', align: 'center', render: r => {
                            if (!r.id_sale) {
                                return ''
                            }
                            return `${r.key_branch_office} - ${r.name_branch_office}`
                        }
                    },
                    { name: 'id_sale', text: 'Id Venta', align: 'center' },
                    {
                        name: 'name_period', text: 'Periodo', align: 'center', render: r => {
                            if (!r.id_sale) {
                                return ''
                            }
                            return `${r.code_period} - ${r.name_period}`
                        }
                    },
                ],
            ]}
            rows={rows}
            pageLength={100}
            isProcessing={isProcessing}
        />
    }, [rows, isProcessing])

    // if (Helpers.date.get({ format: '%Y-%m-%d' }) >= '2026-02-17') {
    //     return <></>
    // }

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Reporte por Producto</span>
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false}>
                    <Select
                        text="Periódo"
                        classNameParent="col-12 mb-2"
                        options={period.map(p => {
                            return {
                                label: p.name_period,
                                value: p.id_period
                            }
                        })}
                        onChange={e => setPeriodSelected(e.value)}
                    />
                    <Input
                        type="text"
                        text="Clave Producto"
                        onChange={e => setProduct(e.currentTarget.value)}
                        append={[
                            <Button onClick={handleSubmit}>
                                <i className="fa fa-search"></i>
                            </Button>
                        ]}
                        placeholder="Clave Producto"
                        classNameParent="col-12 mb-2"
                    />
                </FormCustom>
                {dtRows}
            </Card.Body>
        </Card>
    </>
}

export default ReportePromos